import { CenterCircularProgress, LazyBreadcrumb } from '@europrocurement/flexy-components';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import DocumentTypeShowLayout from './DocumentTypeShowLayout';
import useDocumentType from '../../hooks/useDocumentType';
import { DOCUMENT_TYPE_LIST } from '../../constants/paths';

const DocumentTypeShow: React.FunctionComponent = function () {
    const { documentTypeId } = useParams();
    const { documentType, requestState } = useDocumentType({ documentTypeId });

    if (requestState === 'idle' || requestState === 'loading') {
        return <CenterCircularProgress sx={{ height: '70vh' }} />;
    }

    if (requestState === 'failed' || !documentType) {
        return (
            <Navigate
                to="/errors/404"
                replace
            />
        );
    }

    return (
        <>
            <LazyBreadcrumb
                path={[
                    { path: 'Types de documents', link: DOCUMENT_TYPE_LIST },
                    "Détails d'un type de document",
                    documentType.libelle as string,
                ]}
            />
            <DocumentTypeShowLayout documentType={documentType} />
        </>
    );
};

export default DocumentTypeShow;
